/**
 * 定数設定
 * TODO: `frontend/javascripts/vue/mixin/utility.js` で定数を設定するのをやめる
 */

/**
 * 会員情報入力画面の表示切り分け用の定数
 * @type {{Minimum: string, Normal: string, Full: string}}
 */
export const EnumClientDisplayPattern = {
    Minimum: "00",
    Normal: "01",
    Full: "02"
};
Object.freeze(EnumClientDisplayPattern);

/**
 * Toasted メッセージの表示タイプ用の定数
 * @type {{Warning: string, Error: string, Info: string, Success: string}}
 */
export const EnumAlertType = {
    Success: 'success',
    Info: 'info',
    Warning: 'warning',
    Error: 'error'
};
Object.freeze(EnumAlertType);

/**
 * クラブチームロゴのベースURL
 * @type {string}
 */
export const EMBLEM_IMAGE_BASE_PATH = "https://auth2.jleague.jp/emblem/";

/**
 * リーグ名
 * @type {string[]}
 */
export const LEAGUES = [
    'J1',
    'J2',
    'J3'
];
Object.freeze(LEAGUES);
